import * as React from 'react';

export function SvgChevronLeft() {
  return (
    <span aria-hidden={true} data-testid="ads-refreshed-icon">
      <svg viewBox="-2 -2 16 16">
        <path
          fill="currentColor"
          fillRule="evenodd"
          d="m4.06 6 3.97-3.97L6.97.97l-4.5 4.5a.75.75 0 0 0 0 1.06l4.5 4.5 1.06-1.06z"
          clipRule="evenodd"
        />
      </svg>
    </span>
  );
}
